/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ValidationEventType;

(function (ValidationEventType) {
  ValidationEventType["VALIDATION_IS_SUCCESS"] = "validation.is_success";
  ValidationEventType["VALIDATION_IS_PENDING"] = "validation.is_pending";
  ValidationEventType["VALIDATION_IS_FAILURE"] = "validation.is_failure";
})(ValidationEventType || (ValidationEventType = {}));